// extracted by mini-css-extract-plugin
export var footer = "Footer-module--footer--afd90";
export var footer__copyright = "Footer-module--footer__copyright--31169";
export var footer__hideBorder = "Footer-module--footer__hideBorder--45dc0";
export var footer__links = "Footer-module--footer__links--59b6e";